import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../services/api';

export const useDeleteSitterProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await api.delete('/sitters/profile');
    },
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ['sitterProfile'] });
    },
  });
};
